import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  deleteSinglePendingCustomerSuccessAction,
  getPendingCustomersSuccessAction,
  getSinglePendingCustomerSuccessAction,
  moderateCreateSinglePendingCustomerSuccessAction,
  setPendingCustomersCountAction,
  setPendingCustomersIsLoadingAction,
  updatePendingCustomerSuccessAction,
} from './Actions';

import { push } from 'react-router-redux';
import { authUserIdSelector } from '../../auth/Selectors';
import { actions } from './Reducer';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../notifications/Actions';

import * as api from './Api';

function* getPendingCustomers({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    sort: 'createdAt',
    dir: 'asc',
    filterBy: [],
    filterCountry: '',
  };

  const body = { ...defData, ...payload };
  try {
    yield put(setPendingCustomersIsLoadingAction(true));
    const response = yield call(api.getPendingCustomers, body);
    const { data } = response;
    const { count, content } = data;
    yield put(getPendingCustomersSuccessAction(content));
    yield put(setPendingCustomersCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingCustomersIsLoadingAction(false));
  }
}

function* updatePendingCustomer({ payload }) {
  const moderatorID = yield select(authUserIdSelector);
  const defData = {
    moderatorID,
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingCustomersIsLoadingAction(true));

    yield call(api.updatePendingCustomer, body);

    yield put(newSuccessNotificationAction('Customer Moderated'));

    yield put(updatePendingCustomerSuccessAction(body.moderationRecordID));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingCustomersIsLoadingAction(false));
  }
}

function* getSinglePendingCustomer({ payload }) {
  const id = payload;
  try {
    yield put(setPendingCustomersIsLoadingAction(true));
    const response = yield call(api.getSinglePendingCustomer, id);
    const { data } = response;
    yield put(getSinglePendingCustomerSuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingCustomersIsLoadingAction(false));
  }
}

function* deleteSingelPendingCustomer({ payload }) {
  const id = payload;
  try {
    yield put(setPendingCustomersIsLoadingAction(true));
    yield call(api.deleteSinglePendingCustomer, id);
    yield put(deleteSinglePendingCustomerSuccessAction(id));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingCustomersIsLoadingAction(false));
  }
}

function* moderateCreateSinglePendingCustomer({ payload, mode }) {
  const id = payload;
  try {
    if (mode === 'update') {
      yield put(setPendingCustomersIsLoadingAction(true));
      const response = yield call(api.moderateUpdateSinglePendingCustomer, id);
      const { data } = response;
      yield put(moderateCreateSinglePendingCustomerSuccessAction(id));
      yield put(push('/customers-moderation/customers'));
      yield put(newSuccessNotificationAction('Customer Moderated'));
    } else {
      yield put(setPendingCustomersIsLoadingAction(true));
      const response = yield call(api.moderateSinglePendingCustomer, id);
      const { data } = response;
      yield put(moderateCreateSinglePendingCustomerSuccessAction(id));
      yield put(push('/customers-moderation/customers'));
      yield put(newSuccessNotificationAction('Customer Moderated'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingCustomersIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_PENDING_CUSTOMERS, getPendingCustomers);
  yield takeLatest(
    actions.GET_SINGLE_PENDING_CUSTOMER,
    getSinglePendingCustomer
  );
  yield takeLatest(actions.UPDATE_PENDING_CUSTOMER, updatePendingCustomer);
  yield takeLatest(
    actions.DELETE_SINGLE_PENDING_CUSTOMER,
    deleteSingelPendingCustomer
  );
  yield takeLatest(
    actions.MODERATE_SINGLE_PENDING_CUSTOMER,
    moderateCreateSinglePendingCustomer
  );
}
